// src/pages/publish/components/TreeNode.tsx
import React, { useState } from 'react';
import { ChevronRight, ChevronDown } from 'lucide-react';

interface TreeNodeProps {
  label: React.ReactNode;
  icon: any;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  defaultExpanded?: boolean;
  level?: number;
}

export const TreeNode: React.FC<TreeNodeProps> = ({
  label,
  icon: Icon,
  actions,
  children,
  defaultExpanded = false,
  level = 0
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const hasChildren = React.Children.count(children) > 0;

  return (
    <div className={`mb-1 select-none ${level > 0 ? 'ml-4 border-l border-gray-200 pl-2' : ''}`}>
      <div className="flex items-center justify-between p-2 rounded hover:bg-gray-100 group transition-colors">
        <div 
          className="flex items-center gap-2 cursor-pointer flex-1" 
          onClick={() => hasChildren && setIsExpanded(!isExpanded)}
        >
          {hasChildren ? (
            isExpanded ? <ChevronDown size={16} className="text-gray-400" /> : <ChevronRight size={16} className="text-gray-400" />
          ) : <div className="w-4" />}
          
          <Icon size={16} className="text-blue-600" />
          <span className="text-sm font-medium text-gray-700">{label}</span>
        </div>
        
        {/* 操作按钮区域：默认隐藏，hover显示 */}
        <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
          {actions}
        </div>
      </div>
      
      {isExpanded && children && (
        <div className="mt-1">
          {children}
        </div>
      )}
    </div>
  );
};
